/**
 * Shared guide overlays for arcade playfields.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import React from "react";

export interface ArcadePlayfieldGuideLineProps {
  readonly x: number | string;
  readonly className?: string;
}

export interface ArcadePlayfieldGuideZoneProps {
  readonly x: number | string;
  readonly width: number | string;
  readonly className?: string;
}

export function ArcadePlayfieldGuideLine({
  x,
  className,
}: ArcadePlayfieldGuideLineProps): React.JSX.Element {
  return (
    <div
      aria-hidden
      className={joinClassNames("absolute bottom-0 top-0 w-px", className)}
      style={{ left: arcadePositionValue(x) }}
    />
  );
}

export function ArcadePlayfieldGuideZone({
  x,
  width,
  className,
}: ArcadePlayfieldGuideZoneProps): React.JSX.Element {
  return (
    <div
      aria-hidden
      className={joinClassNames("absolute bottom-0 top-0", className)}
      style={{
        left: arcadePositionValue(x),
        width: arcadePositionValue(width),
      }}
    />
  );
}

function arcadePositionValue(value: number | string): string {
  return typeof value === "number" ? `${value}%` : value;
}

function joinClassNames(
  ...classNames: readonly (string | undefined)[]
): string {
  return classNames.filter(Boolean).join(" ");
}
